import React, { memo, useState } from 'react';
import styles from './GroupItem.module.less';
import otherDefault from '../../../static/wp/wp_other_default.png';
import frameDefault from '../../../static/wp/wp_frame_default.png';
import rectangleDefault from '../../../static/wp/wp_rectangle_default.png';
import img from '../../../static/wp/wp_chose_tag.svg';
import { useDispatch, useSelector } from 'react-redux';
import { setChoiceList } from '../../../actions/wallpaperPay';

export default memo(({ item }) => {
  const dispatch = useDispatch();
  const [showImg, setShowImg] = useState(item.backgroundImg);
  const [has, setHas] = useState(item.hasSelect);
  const handleChoice = () => {
    if (has === 1) {
      dispatch(
        setChoiceList({ has: 0, item: { contentId: item.contentId, groupType: item.groupType } }),
      );
      setHas(0);
    } else {
      dispatch(
        setChoiceList({ has: 1, item: { contentId: item.contentId, groupType: item.groupType } }),
      );
      setHas(1);
    }
  };

  return (
    <div className={styles.group_item} onClick={handleChoice}>
      <div className="img_item">
        {item.groupType === '3' && <img src={rectangleDefault} className={styles.img_ani} />}
        {item.groupType === '4' && <img src={frameDefault} className={styles.img_ani} />}
        {item.groupType !== '3' && item.groupType !== '4' && (
          <img
            src={showImg ?? otherDefault}
            onError={() => {
              setShowImg(otherDefault);
            }}
            className={styles.img_ani}
          />
        )}
        {has === 1 && (
          <div className="mask">
            <img src={img} className="mask_img" />
          </div>
        )}
        {has === 0 && <div className="mask_nochoice" />}

        {item.groupType === '3' && (
          <div className="img_item_title">
            <i className="iconfont icon-wp_turn_cy wp_icon" /> {item.contentName}
          </div>
        )}
        {item.groupType === '4' && (
          <div className="img_item_title">
            <i className="iconfont icon-wp_turn_sc wp_icon" /> {item.contentName}
          </div>
        )}
        {item.groupType !== '3' && item.groupType !== '4' && (
          <div className="img_item_title">{item.contentName}</div>
        )}
      </div>
    </div>
  );
});
